module.exports = __webpack_public_path__ + "static/media/kids-street-convo.33a59e99.mov";